import { ACTION_TYPE } from '../actions/actionTypes';

const { STEPS } = ACTION_TYPE;

const stepsReducer = (state = {}, action) => {
  switch (action.type) {
    case STEPS.UPDATA_CURRENT_STEP:
      return { ...state, currentStep: action.payload.currentStep };
    case STEPS.UPDATE_STEP_SUCCESS:
      return { ...state, steps: action.payload.steps, error: null };
    case STEPS.UPDATE_STEP_FAIL:
      return { ...state, error: action.payload.error };
    default:
      return state;
  }
};

export default stepsReducer;
